import { combineReducers } from 'redux';

import isFetching from './isFetching';

/**
 * @typedef {{
 *   isFetching: boolean
 * }} ClippingUIReducer
 */
export default combineReducers({
  isFetching,
});
